import { render } from "./SidenavCollapseItem.vue?vue&type=template&id=bfa80eb2"
import script from "./SidenavCollapseItem.vue?vue&type=script&lang=js"
export * from "./SidenavCollapseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__